import { render, staticRenderFns } from "./WeekDaysNav.vue?vue&type=template&id=461528e6&"
import script from "./WeekDaysNav.vue?vue&type=script&lang=js&"
export * from "./WeekDaysNav.vue?vue&type=script&lang=js&"
import style0 from "./WeekDaysNav.vue?vue&type=style&index=0&id=461528e6&prod&scpoed=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports